import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CommunityService} from '../../api/resources/community/community.service';
import {ToasterService} from '../../global/toaster.service';

type PaneType = 'left' | 'right';

@Component({
  selector: 'app-report-supplier',
  templateUrl: './report-supplier.component.html',
  styleUrls: ['./report-supplier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slide', [
      state('left', style({ transform: 'translateX(0)' })),
      state('right', style({ transform: 'translateX(-50%)' })),
      transition('* => *', animate(300))
    ])
  ]
})
export class ReportSupplierComponent implements OnInit {
  supplier: any;
  activePane: PaneType = 'left';
  selectedReason = '';
  details = '';
  reasons = [
    'It\'s a false company',
    'Intellectual property violation',
    'Fraudulent behaviour',
    'Hate speech, harassment or violence',
    'Nudity or pornography',
    'Other'
  ];
  submittingReport = false;

  constructor(
    public activeModal: NgbActiveModal,
    private _communityService: CommunityService,
    private _toasterService: ToasterService) { }

  ngOnInit() {
  }

  selectReason(reason: string) {
    this.selectedReason = reason;
    this.activePane = 'right';
  }

  submitReport() {
    this.submittingReport = true;
    this._communityService.sendReportAbuseAboutSupplier(
      null,
      this.supplier.id,
      this.details ? this.selectedReason + '<br>' + this.details : this.selectedReason
    ).subscribe(
      (response) => {
        if (response.serverInfo) {
          this._toasterService.showInfo(response.serverInfo.message);
        }
        this.activeModal.dismiss('Submit');
      },
      undefined,
      () => this.submittingReport = false
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/report-supplier/report-supplier.component.ts